import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { WalletService } from '../../../shared/services/wallet.service';
import { DialogService } from '../../../shared/services/dialog.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { StorageService } from 'src/app/shared/services/storage.service';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
@Component({
    selector: 'app-fund-wallet-dialog',
    templateUrl: './fund-wallet-dialog.component.html',
    styleUrls: ['./fund-wallet-dialog.component.scss'],
    imports: [FormsModule, ReactiveFormsModule]
})
export class FundWalletDialogComponent implements OnInit {
  amount: number | undefined;
  profile: any;
  publicKey = environment.wallet.raveKey;
  customerDetails: any;
  meta: any;
  paymentData: any;
  isLoading: boolean = false;
  flwHandler: any;
  constructor(
    private walletService: WalletService,
    private dialogService: DialogService,
    private notification: NotificationService,
    private storage: StorageService
  ) {}

  ngOnInit(): void {
    this.getProfileData();
  }

  onFundWallet() {
    return;
    this.isLoading = true;
    if (!this.profile) {
      this.isLoading = false;
      return;
    }

    this.dialogService.openLoadingDialog();
    const transactionPayload = {
      amount: this.amount,
      creator_user_id: this.profile.userID,
      creator_email: this.profile.emailAddress,
      platform: 'WEB',
    };

    this.walletService.inititateTransactions(transactionPayload).subscribe(
      (res: any) => {
        this.dialogService.closeFundWalletDialog();
        this.paymentData.tx_ref = res.id;
        this.paymentData.amount = this.amount;

        this.flwHandler = (window as any).FlutterwaveCheckout({
          ...this.paymentData,
          redirect_url: '',
          callback: (data: any) => {
            setTimeout(() => {
              this.paymentSuccess(res.id);
            }, 0);
          },
          onclose: () => this.closeFlwDialog(),
        });
      },
      (err) => {
        this.dialogService.closeLoadingModal();
        this.dialogService.closeFundWalletDialog();
        this.notification.error("It's not you, it's us please try again");
      }
    );
  }

  paymentSuccess(data: any) {
    this.walletService.verifyTransactions(data).subscribe(
      (res: any) => {
        this.closeFlwDialog();
        this.isLoading = false;
        this.dialogService.openFailedTransactionDialog(res).result.then(() => {
          this.walletService.getBalance();
          this.walletService.getTransactions();
        });
      },
      (err) => {
        this.walletService.getBalance();
        this.walletService.getTransactions();
        this.notification.error(
          'unable to verify the status of the transaction at the moment, kindly refresh your balance'
        );
      }
    );
  }

  closeFlwDialog() {
    this.dialogService.closeLoadingModal();
    if (this.flwHandler !== null) {
      setTimeout(() => {
        this.flwHandler.close();
      }, 1000);
    }
  }

  getProfileData() {
    this.profile = this.storage.get('user');
    this.customerDetails = {
      name: `${this.profile?.name} ${this.profile?.family}`,
      email: this.profile?.emailAddress,
      phone_number: this.profile?.mobileNumber,
    };

    this.meta = { counsumer_id: this.profile?.userID, consumer: this.profile };

    this.paymentData = {
      public_key: this.publicKey,
      tx_ref: '',
      amount: 0,
      currency: 'NGN',
      payment_options: 'card, banktransfer, ussd',
      meta: this.meta,
      customer: this.customerDetails,
    };
  }
}
